var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.207,
    height: 15.207,
    viewBox: "0 0 15.207 15.207",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3844467_magnifier_search_zoom_icon",
    "data-name": "3844467_magnifier_search_zoom_icon",
    transform: "translate(-4.5 -4.919)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_42_",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(5 5.419)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_44_",
    x1: 3.5,
    y1: 3.5,
    transform: "translate(15.5 15.919)",
    fill: "none",
    stroke: "gray",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.d90d50721b677b7924a517437d6d7512.svg";
export { ForwardRef as ReactComponent };